import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RateLimitedRequestQueue } from '@pure1/data';

// current Kong rate limit for SPOG is 100 req/sec/IP
export const PACED_REQUESTS_PER_SECOND = 50;

// Endpoints Planner's license table calls once per license, so a large page would otherwise burst past the limit.
const PACED_ENDPOINTS = ['/rest/v1/analysis/aggregatedmetrics/metrics', '/rest/v2/forecast/licenses/effective-used'];

// Sits below both response caches, which call HttpClient only on a miss, so a cache hit is never queued.
@Injectable()
export class RequestPacingInterceptor implements HttpInterceptor {
    private readonly queue = new RateLimitedRequestQueue(PACED_REQUESTS_PER_SECOND);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!PACED_ENDPOINTS.includes(req.url)) {
            return next.handle(req);
        }
        return this.queue.queueRequest(next.handle(req));
    }
}
